import { API_SERVER } from 'config/constant';
import { getMethod, postMethod, putMethod, urls } from 'utils/url/urls';

function normalizeFunctionResponse(result) {
  if (result && (Object.prototype.hasOwnProperty.call(result, 'data') || Object.prototype.hasOwnProperty.call(result, 'error'))) {
    return result;
  }

  return { data: result, error: null };
}

export async function assessmentCreate(data) {
  try {
    const response = await fetch(`${API_SERVER}${urls.assessmentCreate}`, postMethod(data));
    return await response.json();
  } catch (err) {
    console.log('assessmentCreate Error:', err.message);
  }
}

export async function assessmentUpdate(data, id) {
  try {
    const response = await fetch(`${API_SERVER}${urls.assessmentUpdate}${id}`, putMethod(data));
    const result = await response.json();
    if (!response.ok) {
      return { status: 'Error', message: result.message || 'Request failed' };
    }
    return result;
  } catch (err) {
    console.log('assessmentUpdate Error:', err.message);
    return { status: 'Error', message: 'Network error' };
  }
}

export async function assessmentGet(id) {
  try {
    const response = await fetch(`${API_SERVER}${urls.assessmentGet}${id}`, getMethod());
    return await response.json();
  } catch (err) {
    console.log('assessmentGet Error:', err.message);
  }
}

export async function assessmentValidate(data) {
  try {
    console.log('[assessmentValidate] request', {
      url: `${API_SERVER}${urls.assessmentValidate}`,
      payload: data,
    });
    const response = await fetch(`${API_SERVER}${urls.assessmentValidate}`, postMethod(data));
    const result = await response.json();
    console.log('[assessmentValidate] response', result);
    if (!response.ok) {
      return { data: null, error: { message: result.message || result.error || 'Failed to validate transcript' } };
    }
    return normalizeFunctionResponse(result);
  } catch (err) {
    console.log('assessmentValidate Error:', err.message);
    return { data: null, error: { message: err.message || 'Network error' } };
  }
}

export async function assessmentStt(data) {
  try {
    const response = await fetch(`${API_SERVER}${urls.assessmentStt}`, postMethod(data));
    return await response.json();
  } catch (err) {
    console.log('assessmentStt Error:', err.message);
  }
}

export async function assessmentEvaluate(data) {
  try {
    console.log('[assessmentEvaluate] request', {
      url: `${API_SERVER}${urls.assessmentEvaluate}`,
      payload: data,
    });
    const response = await fetch(`${API_SERVER}${urls.assessmentEvaluate}`, postMethod(data));
    const result = await response.json();
    console.log('[assessmentEvaluate] response', result);
    if (!response.ok) {
      return { data: null, error: { message: result.message || result.error || 'Failed to evaluate responses' } };
    }
    return normalizeFunctionResponse(result);
  } catch (err) {
    console.log('assessmentEvaluate Error:', err.message);
    return { data: null, error: { message: err.message || 'Network error' } };
  }
}
